"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundaryGlobalIdRefSchema = exports.IBoundaryInstanceSchema = void 0;
const zod_1 = require("zod");
const ComponentBoundary_1 = require("../ComponentBoundary");
exports.IBoundaryInstanceSchema = ComponentBoundary_1.ComponentBoundarySchema.extend({
    moduleName: zod_1.z.string().optional(),
    functionName: zod_1.z.string().optional(),
    globalId: zod_1.z.string(),
});
exports.BoundaryGlobalIdRefSchema = zod_1.z
    .union([zod_1.z.string(), zod_1.z.object({ globalId: zod_1.z.string() }).passthrough()])
    .transform((v) => (typeof v === 'string' ? v : v.globalId));
//# sourceMappingURL=IBoundaryInstance.js.map